import { render } from "./ObjectDashboard.vue?vue&type=template&id=37e3091d&scoped=true"
import script from "./ObjectDashboard.vue?vue&type=script&lang=js"
export * from "./ObjectDashboard.vue?vue&type=script&lang=js"

import "./ObjectDashboard.vue?vue&type=style&index=0&id=37e3091d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e3091d"]])

export default __exports__